package org.moxultimate.topwithmox.product.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * ProductContentTagResponse
 * Single row returned by GET /product-content-tag.
 * The [tag] string is used to populate filter chips and search autocomplete.
 *
 * @param id Auto-generated database ID.
 * @param tag Tag label stored in the product_content_tags table.
 */
@Serializable
data class ProductContentTagResponse(
    @SerialName("id") val id: Long,
    @SerialName("tag") val tag: String? = null,
)
